/**
* Animated Laptop Screens JS
* -----------------------------------------------------------------------------
*
* All the JS for the Animated Laptop Screens component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
import lottie from 'lottie-web';
( function( app ) {
  const COMPONENT = {

    className: 'animated-laptop-screens',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      gsap.registerPlugin( ScrollTrigger );
      $( '.animated-laptop-screens' ).each( function( key, val ) {
        const laptopAnimation = lottie.loadAnimation( {
          container: $( val ).find( '.laptop-animation' )[0],
          renderer: 'svg',
          name: 'laptop-animation',
          loop: false,
          autoplay: false,
          path: $( val ).find( '.laptop-animation' ).attr( 'data-url' ),
        } );

        let navHeight = $( '.navbar' ).outerHeight();

        if ( $( '#wpadminbar' ).length ) {
          navHeight += $( '#wpadminbar' ).outerHeight();
        }

        const timeObj = {currentFrame: 0};
        const objDuration = 1;
        const panelHeight = window.innerHeight;
        const height = panelHeight * $( val ).find( '.content' ).length;
        $( val ).height( height + window.innerHeight );
        const pinner = gsap.timeline( {
          scrollTrigger: {
            trigger: val,
            start: 'top top',
            end: '+=' + height,
            scrub: 0,
            pin: $( val ).find( '.inner-area' )[0],
            pinSpacing: false,
            onEnter: ( {progress, direction, isActive} ) => $( val ).addClass( 'is-reached' ),
            onLeaveBack: ( {progress, direction, isActive} ) => $( val ).removeClass( 'is-reached' ),
            onUpdate: ( self ) => {
              if ( objDuration ) {
                gsap.to( timeObj, {
                  duration: objDuration,
                  currentFrame: ( Math.floor( self.progress * ( laptopAnimation.totalFrames - 1 ) ) ),
                  onUpdate: () => {
                    laptopAnimation.goToAndStop( timeObj.currentFrame, true );
                  },
                  ease: 'expo',
                } );
              } else {
                laptopAnimation.goToAndStop( self.progress * ( laptopAnimation.totalFrames - 1 ), true );
              }
            },
          },
        } );

        $( this ).find( '.content' ).each( function( contentKey, contentVal ) {
          const bannerHeight = $( contentVal ).outerHeight();
          const sectionStart = panelHeight * contentKey;

          const tl = gsap.timeline( {
            scrollTrigger: {
              trigger: val,
              start: ( sectionStart + 'px' ) + ' top',
              end: '+=' + panelHeight,
              scrub: 0,
              // markers: true,
              onEnter: ( {progress, direction, isActive} ) => $( contentVal ).addClass( 'is-reached' ),
              onEnterBack: ( {progress, direction, isActive} ) => $( contentVal ).addClass( 'is-reached' ),
              onLeave: ( {progress, direction, isActive} ) => {
                if ( contentVal !== $( val ).find( '.content:last-child' )[0] ) {
                  $( contentVal ).removeClass( 'is-reached' );
                }
              },
              onLeaveBack: ( {progress, direction, isActive} ) => $( contentVal ).removeClass( 'is-reached' ),
            },
          } );
        } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'animated-laptop-screens', COMPONENT );
} )( app );
